import { date } from 'quasar'

const PRIORITY_LABELS = { 1: 'Baja', 2: 'Media', 3: 'Alta' }
const PRIORITY_COLORS = { 1: 'green', 2: 'orange', 3: 'red' }
const PRIORITY_TEXT_KEYS = { 1: 'tasks.priority.low', 2: 'tasks.priority.medium', 3: 'tasks.priority.high' }
const PRIORITY_DEFAULT_DAYS = { 1: 10, 2: 5, 3: 1 }

const formatDay = value => date.formatDate(value, 'YYYY-MM-DD')

export function isEndDateMissing (endDate) {
  return !endDate || endDate.startsWith('0000-00-00')
}

export function isTaskIncomplete (task) {
  return task.title === null
    || task.priority === null || task.priority === 0
    || task.role_id === null || typeof task.role_id !== 'number'
    || typeof task.assigned_to_id !== 'number' || task.assigned_to_id === null
    || isEndDateMissing(task.end_date)
}

export function normalizePriority (priority) {
  if (priority === null || priority === undefined || priority === '') return null
  const value = Number(priority)
  return Number.isNaN(value) ? null : value
}

export function priorityLabel (priority) {
  return PRIORITY_LABELS[normalizePriority(priority)] ?? null
}

// Llave de i18n del texto visible de la prioridad (priorityLabel es el valor en espanol que se compara y se guarda).
export function priorityTextKey (priority) {
  return PRIORITY_TEXT_KEYS[normalizePriority(priority)] ?? null
}

export function priorityColor (priority) {
  return PRIORITY_COLORS[normalizePriority(priority)] ?? 'gray'
}

export function priorityValue (label) {
  const entry = Object.entries(PRIORITY_LABELS).find(([, text]) => text === label)
  return entry ? Number(entry[0]) : undefined
}

export function endDateForPriority (priority, prioritySettings, now = Date.now()) {
  const setting = prioritySettings?.find(p => priority === Number(p.value))
  if (setting) {
    const endDate = formatDay(date.addToDate(now, {
      days: setting.unit === 'd' ? setting.time : 0,
      hours: setting.unit === 'h' ? setting.time : 0
    }))
    return endDate > formatDay(now) ? endDate : formatDay(date.addToDate(now, { days: 1 }))
  }
  if (!(priority in PRIORITY_DEFAULT_DAYS)) return undefined
  return formatDay(date.addToDate(now, { days: PRIORITY_DEFAULT_DAYS[priority] }))
}
